import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, BookOpen, Users } from 'lucide-react';
export function FooterCTA() {
  return <section className="py-24 bg-amber-500 text-gray-900" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-87">
          <h2 className="text-4xl md:text-5xl font-bold mb-12 tracking-tight" data-id="element-88">
            Ready to transform knowledge into impact?
          </h2>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4" data-id="element-89">
            <button className="w-full md:w-auto flex items-center justify-center gap-2 bg-gray-900 hover:bg-gray-800 text-white px-8 py-4 rounded-md font-bold text-lg transition-colors shadow-lg" data-id="element-90">
              <MessageSquare size={20} data-id="element-91" />
              Start a Conversation
            </button>
            <button className="w-full md:w-auto flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-gray-900 px-8 py-4 rounded-md font-bold text-lg transition-colors shadow-lg" data-id="element-92">
              <BookOpen size={20} data-id="element-93" />
              Build a Livable Book
            </button>
            <button className="w-full md:w-auto flex items-center justify-center gap-2 bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 rounded-md font-bold text-lg transition-colors shadow-lg" data-id="element-94">
              <Users size={20} data-id="element-95" />
              Activate Your Community
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}